import { Recommendations } from 'recommend/RecommendUtils'
import { StepOptions, StepVariable } from '@order/steps/types'

import DefaultTemplate from '@order/steps/templates/Default/DefaultTemplate'
import OptionImageTile from './Option/OptionImageTile'

interface Props {
  title?: string
  desc?: string
  options: StepOptions
  recommendations?: Recommendations
  variable?: StepVariable | null
}

export default function ImageTilesTemplate(props: Props) {
  return <DefaultTemplate {...props} OptionComponent={OptionImageTile} />
}
